import { render, staticRenderFns } from "./NetworkSpeed.vue?vue&type=template&id=eb91240c"
import script from "./NetworkSpeed.vue?vue&type=script&lang=js"
export * from "./NetworkSpeed.vue?vue&type=script&lang=js"
import style0 from "./NetworkSpeed.vue?vue&type=style&index=0&id=eb91240c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports